import { createSlice } from '@reduxjs/toolkit';

const initialState: initialStateType = {
  view: 'grid',
  query: { sort: 'asc', search: '' },
};

const stateSlice = createSlice({
  name: 'menuList/state',
  initialState: initialState,
  reducers: {
    toggleView: (state, action) => {
      state.view = action.payload;
    },
    toggleSort: (state, action) => {
      state.query.sort = action.payload;
    },
    setSearch: (state, action) => {
      state.query.search = action.payload;
    },
  },
});

export const { toggleView, toggleSort, setSearch } = stateSlice.actions;
export default stateSlice.reducer;
interface initialStateType {
  view: 'grid' | 'list';
  query: { sort: 'asc' | 'desc'; search: string };
}
